module.exports = __webpack_public_path__ + "static/media/draw-people.41f8b740.svg";